/**
 * 列表标题「共 N 个」：必须用接口 total（已发布 + 当前筛选的全量条数），
 * 不得用已滚动加载的 items.length。
 */
export function resolveMaterialHubListTotal(totalItems, itemsLength, loading) {
  if (typeof totalItems === 'number' && Number.isFinite(totalItems) && totalItems >= 0) {
    return totalItems;
  }
  if (loading) return null;
  return typeof itemsLength === 'number' ? itemsLength : 0;
}

/** 素材中心 · 排序选项（仅 UI 文案，数据来自后端 material-hub API） */
export const MATERIAL_HUB_SORT_OPTIONS = [
  { id: 'comprehensive', label: '综合排序' },
  { id: 'latest', label: '最新上架' },
];

export const MATERIAL_HUB_FAVORITES_KEY = 'ipe-material-hub-favorites-v1';
